import { LayoutMode } from '../../../components/layout-buttons/types';

export const SET_PRODUCT_COLLECTION_LAYOUT = 'SET_PRODUCT_COLLECTION_LAYOUT';
export const ADD_PRODUCT_COLLETION_WITH_FITLERS_TO_HISTORY =
  'ADD_PRODUCT_COLLETION_WITH_FITLERS_TO_HISTORY';

export type SetProductCollectionLayoutAction = {
  type: typeof SET_PRODUCT_COLLECTION_LAYOUT;
  layout: LayoutMode;
};

export type AddProductCollectionWithFiltersToHistoryAction = {
  type: typeof ADD_PRODUCT_COLLETION_WITH_FITLERS_TO_HISTORY;
  id: string;
  state: any;
};

export const setProductCollectionLayout = (
  layout: LayoutMode
): SetProductCollectionLayoutAction => ({
  type: SET_PRODUCT_COLLECTION_LAYOUT,
  layout,
});

export const addProductCollectionWithFiltersToHistory = (
  id: string,
  state: any
): AddProductCollectionWithFiltersToHistoryAction => ({
  type: ADD_PRODUCT_COLLETION_WITH_FITLERS_TO_HISTORY,
  id,
  state,
});

export type ProductCollectionAction =
  | SetProductCollectionLayoutAction
  | AddProductCollectionWithFiltersToHistoryAction;
